import React, { useState, useEffect } from 'react'
import '../App.css'
import axios from 'axios'
import { SERVER_URI } from '../utility/config'
import DatePicker from 'react-datepicker'
import moment from 'moment'
import 'react-datepicker/dist/react-datepicker.css'
import LoginRequest from './LoginRequest'
import fi from 'date-fns/locale/fi' // the locale you want

function CompletedOrdersDriver(props) {
  props.stopListRefresh()
  const [startDate, setStartDate] = useState(new Date())
  const [driverList, setDriverList] = useState([])
  const [isloggedIn, setIsloggedIn] = useState(true)
  let storage = window.localStorage
  let userToken = storage.getItem('admin_token')

  useEffect(() => {
    const fetchData = async () => {
      let driverlist
      startDate.setHours(0, 0, 0, 0)
      let startDateToServer = new Date(Date.parse(startDate)).toString()
      const startOfMonth = moment().startOf('month').format('YYYY-MM-DD hh:mm')
      if (
        new Date(startOfMonth).getDate() !==
        new Date(startDateToServer).getDate()
      ) {
        let temporaryStartDate = new Date(startOfMonth)
        temporaryStartDate.setHours(0, 0, 0, 0)
        startDateToServer = new Date(Date.parse(temporaryStartDate)).toString()
      }
      var lastDayOfMonth = new Date(
        startDate.getFullYear(),
        startDate.getMonth() + 1,
        0
      )
      lastDayOfMonth.setHours(23, 59, 59, 59)
      let comparisonDate = moment(lastDayOfMonth) // moment(...) can also be used to parse dates in string format
      const dataToServer = {
        startDate: startDateToServer,
        comparisonDate: comparisonDate,
      }
      if (userToken === null) {
        console.log('kirjaudu sisään')
        setIsloggedIn(false)
      } else {
        try {
          driverlist = await axios.post(
            `${SERVER_URI}/list_drivers_Report/`,
            dataToServer,
            { headers: { Authorization: `Token ${userToken}` } }
          )
        } catch (e) {
          console.log('Error in getting drivers', e)
        }
        setDriverList(driverlist.data)
      }
    }
    fetchData()
  }, [startDate, userToken])

  return (
    <div>
      <h2>Ajetut tilaukset</h2>
      <span>
        <div className='completedOrders'>
          <span>Kuukausi: </span>
          <DatePicker
            selected={startDate}
            onChange={(date) => setStartDate(date)}
            dateFormat='MM/yyyy'
            locale={fi}
            showMonthYearPicker
            placeholderText='Kuukausi'
          />
          <table id='driversTable'>
            <thead>
              <tr>
                <th>Kuljettaja</th>
                <th>Kyytien määrä</th>
                <th>Käytetty bonus</th>
              </tr>
            </thead>
            <tbody>
              {driverList
                .sort((a, b) =>
                  a.name > b.name ? 1 : b.name > a.name ? -1 : 0
                )
                .map((driver, index) => (
                  <tr key={index} id={driver.id}>
                    <td>{driver.name} </td>
                    <td>{driver.ordersIn30Days}</td>
                    <td>
                      {driver.bonusIn30Days === null ? 0 : driver.bonusIn30Days}{' '}
                      €
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
        {!isloggedIn && <LoginRequest />}
      </span>
    </div>
  )
}

export default CompletedOrdersDriver
